import{widthPropDefs as t}from"../props/index.js";const e={content:{type:"ReactNode",required:!0},width:t.width,minWidth:t.minWidth,maxWidth:{...t.maxWidth,default:"360px"}};export{e as tooltipPropDefs};
//# sourceMappingURL=tooltip.props.js.map
